import React, { Component } from 'react'
import { Link } from "react-router-dom";
import logo from './logo.svg'
import instagram from './instagram.svg'
import email from './email.svg'
import facebook from './facebook.svg'
import QR from './QR.jpg'
import './Footer.css'

export default class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: window.innerWidth <= 480,
    };
  }
  render() {
    const {
      isMobile
    } = this.state;
    return (
      <div className='footer_container'>
        <div className='footer'>
          <div className='logo-container'>
          {!isMobile && 
             <Link to={'/'} className='footer_logo'onClick={() => { window.scroll(0, 0); }}>
                  <img className = "footer_logo_img" src={logo} alt="" />
            </Link>}
          </div>
          <div className='social_container'>
          {isMobile && 
             <Link to={'/'} className='footer_logo'onClick={() => { window.scroll(0, 0); }}>
                  <img className = "footer_logo_img" src={logo} alt="" />
            </Link>}
            <div className='followUs'>Follow Us</div>
            <div className='social_icons'>
              <a className='social_logo' href="https://www.linkedin.com/company/28871880/" target="_blank">
                <img className='social_logo_img' src={instagram} alt="" />
              </a>
              <a className='social_logo2' href="mailto:Blake@svlc.tech" target="_blank">
                <img className='social_logo_img2' src={email} alt="" />
              </a>
              <a className='social_logo' href="https://www.facebook.com/svlc.tech/" target="_blank">
                <img className='social_logo_img' src={facebook} alt="" />
              </a>
            </div>
          </div>
          <div className='QR_container'>
            <div class="QR_title">SVLC Assistant</div>
            <div className='QR_content'>
              <img src={QR} alt="pic" />
              <h4 className='QR_text'>For more information please scan SVLC Assistant QR code</h4>
            </div>
          </div>
        </div>
        <hr className='footer_hr'/>
        <h1 className='footer_text'>Copyright ©2023 SVLC. All rights reserved </h1>
      </div>
    )
  }
}
